import type { IconSvgObject } from './types';

const BurningCdIcon: IconSvgObject = [
  ["path", { d: "M5.5 22H11.5C13.1569 22 14.5 20.6569 14.5 19V5C14.5 3.34315 13.1569 2 11.5 2H5.5C3.84315 2 2.5 3.34315 2.5 5V19C2.5 20.6569 3.84315 22 5.5 22Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M14.5 15C16.1569 15 17.5 13.6569 17.5 12C17.5 10.3431 16.1569 9 14.5 9", stroke: "currentColor", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M14.5 19C18.366 19 21.5 15.866 21.5 12C21.5 8.13401 18.366 5 14.5 5", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M11.5 13.5V10.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }]
];

export default BurningCdIcon;
